import React, { useState, useEffect, useRef } from 'react';
import {
  Avatar,
  Typography,
  IconButton,
  Tooltip,
  Card,
  Box,
  CircularProgress,
  Alert,
} from '@mui/material';
import {
  Flip,
  RotateRight as RotateRightIcon,
} from '@mui/icons-material';

/**
 * ImagePreview - Component for previewing images with rotation
 */
export const ImagePreview = ({ 
  file,
  imageUrl,
  loading,
  error,
  compareMode = false,
  side = "center",
  rotation,
  onRotate,
}) => {
  const [yOffset, setYOffset] = useState(50);
  const containerRef = useRef(null);
  const imageRef = useRef(null);

  const handleMouseMove = (e) => {
    const { top, height } = e.currentTarget.getBoundingClientRect();
    const relativeY = ((e.clientY - top) / height) * 100;
    setYOffset(Math.min(100, Math.max(0, relativeY)));
  };

  return (
    <Card
      key={file.file_id}
      sx={{
        bgcolor: 'background.paper',
        flex: 1,
        display: 'flex',
        overflow: 'hidden',
        position: 'relative',
        '&::after': {
          content: '""',
          position: 'absolute',
          top: 0,
          right: 0,
          width: 0,
          height: 0,
          borderTop: '30px solid',
          borderTopColor: side === "center" ? 'transparent' : side === "right" ? 'info.main' : 'warning.main',
          borderLeft: '30px solid transparent',
        },
      }}
    >
      {compareMode && (
        <>
          <Tooltip title="Rotate">
            <IconButton
              onClick={() => (onRotate(current => (current+90)))}
              size="small"
              sx={{
                position: 'absolute',
                top: 8,
                left: 8,
                zIndex: 10,
                bgcolor: 'background.paper',
                boxShadow: 1,
                '&:hover': {
                  bgcolor: 'action.hover',
                },
              }}
            >
              <RotateRightIcon fontSize="small" />
            </IconButton>
          </Tooltip>
          {/* <Tooltip title="Flip">
            <IconButton
              size="small"
              sx={{
                position: 'absolute',
                top: 8,
                left: 42,
                zIndex: 10,
                bgcolor: 'background.paper',
                boxShadow: 1,
                '&:hover': {
                  bgcolor: 'action.hover',
                },
              }}
            >
              <Flip fontSize="small" />
            </IconButton>
          </Tooltip> */}
        </>
      )}
      {loading && (
        <Box display="flex" justifyContent="center" alignItems="center" minHeight={200}>
          <CircularProgress />
        </Box>
      )}
      {error && (
        <Alert severity="error" sx={{ m: 2 }}>
          {error}
        </Alert>
      )}
      {imageUrl && !loading && (
        <Box
         sx={{
           flex: 1,
           backgroundImage: `url(${imageUrl})`,
           backgroundSize: 'contain',
           backgroundPosition: compareMode ? `${side} ${yOffset}%` : side, // dynamic vertical position in comp mode, inverted for 90/270 rotation
           backgroundRepeat: 'no-repeat',
           transition: 'transform 0.3s ease',
         }}
         onMouseMove={handleMouseMove}
       />
      )}
    </Card>
  );
};